import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TeacherState {
  selectedTeacherId: string | null;
  filterSubject: string | null;
}

const initialState: TeacherState = {
  selectedTeacherId: null,
  filterSubject: null,
};

const teacherSlice = createSlice({
  name: 'teacher',
  initialState,
  reducers: {
    setSelectedTeacher(state, action: PayloadAction<string | null>) {
      state.selectedTeacherId = action.payload;
    },
    setTeacherFilter(state, action: PayloadAction<string | null>) {
      state.filterSubject = action.payload;
    },
    clearTeacherFilters(state) {
      state.filterSubject = null;
    },
  },
});

export const { setSelectedTeacher, setTeacherFilter, clearTeacherFilters } = teacherSlice.actions;
export default teacherSlice.reducer;